<template>
  <div class="broadcast-call-page">
    <div class="top-container">
      <div class="operate-area">
        <el-button
          class="icon iconfont-lunan icon-lunan-maikefeng buttonBlue"
          @click="handleIntercom(true)"
          :disabled="showPlay"
          type="primary"
        >
          远程喊话
        </el-button>
        <div class="call-area intercom map-blur-panel">
          <div class="intercom-title">
            远程喊话（{{ intercomInfo.processing ? "正在喊话" : "停止喊话" }}）
          </div>
          <template v-if="intercomInfo.deviceList && intercomInfo.deviceList.length">
            <div
              class="intercom-device"
              @mouseover="intercomInfo.showDeviceList = true"
              @mouseout="intercomInfo.showDeviceList = false"
            >
              <div class="intercom-device-item click-able">
                <i class="iconfont-lunan icon-lunan-radio"></i>
                <div :title="intercomInfo.deviceList[0].name" class="device-name">
                  {{ intercomInfo.deviceList[0].name }}
                </div>
                <i
                  class="el-icon-caret-bottom device-expand-icon"
                  :class="{ expand: intercomInfo.showDeviceList }"
                ></i>
              </div>
              <div
                class="device-list-area bottom map-blur-panel__title"
                :style="{
                  height: (intercomInfo.deviceList.length - 1) * 30 + 'px',
                }"
                :class="{ hidden: !intercomInfo.showDeviceList }"
              >
                <el-scrollbar style="height: calc (100% - 50px)">
                  <template v-for="(item, index) in intercomInfo.deviceList">
                    <div
                      v-if="index !== 0"
                      class="intercom-device-item click-able"
                      :key="'intercom-device-' + index"
                      :title="item.name"
                    >
                      <i class="iconfont-lunan icon-lunan-radio"></i>
                      <div class="device-name" :title="item.name">
                        {{ item.name }}
                      </div>
                    </div>
                  </template>
                </el-scrollbar>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="intercom-device">
              <div class="device-name">无广播设备</div>
            </div>
          </template>
          <div
            v-if="intercomInfo.deviceList && intercomInfo.deviceList.length"
            style="display: contents"
          >
            <div class="intercom-operate">
              <div class="click-able operate-btn" @click="toggleStopIntercom">
                <el-tooltip
                  :content="intercomInfo.processing ? '停止喊话' : '继续喊话'"
                  effect="dark"
                  placement="top"
                >
                  <i
                    :class="
                      intercomInfo.processing
                        ? 'el-icon-video-pause play-icon'
                        : 'el-icon-video-play stop-icon'
                    "
                  ></i>
                </el-tooltip>
                <!-- <div
              :class="intercomInfo.processing ? 'stop-icon' : 'play-icon'"
            ></div> -->
                <div class="operate-text">
                  <!-- {{ intercomInfo.processing ? "停止喊话" : "继续喊话" }} -->
                </div>
              </div>
            </div>
            <div
              class="intercom-volume"
              :class="{ 'click-able': intercomInfo.processing }"
              @mouseover="intercomInfo.showVolume = intercomInfo.processing"
              @mouseout="intercomInfo.showVolume = false"
            >
              <div class="intercom-volume-bar active">
                <el-slider
                  v-model="intercomInfo.broadcastVolume"
                  :max="15"
                  @change="
                    (val) => {
                      handleVoice(val, intercomInfo.deviceList);
                    }
                  "
                ></el-slider>
              </div>
              <i class="iconfont-lunan icon-lunan-guangbo"></i>
            </div>
            <el-tooltip content="关闭喊话" effect="dark">
              <div class="intercom-close click-able" @click="closeIntercom">
                <i class="el-icon-close"></i>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="operate-area">
        <el-button
          class="icon iconfont-lunan icon-lunan-yinle buttonBlue"
          @click="togglePlayForm(true)"
          :disabled="showIntercom"
          type="primary"
        >
          播放音频
        </el-button>

        <!-- <el-button
          class="icon iconfont-lunan icon-lunan-yinle buttonBlue"
          @click="togglePlayForm(true)"
          :disabled="showIntercom"
          type="primary"
        >
          播放音频
        </el-button> -->
        <div class="call-area play map-blur-panel">
          <!-- v-if="!playInfo.isEmpty" -->
          <div class="intercom-title">
            播放音频{{ playInfo.processing ? "（正在播放）" : "（暂停播放）" }}
          </div>
          <template v-if="playInfo.deviceList && playInfo.deviceList.length">
            <div
              class="intercom-device"
              @mouseover="playInfo.showDeviceList = true"
              @mouseout="playInfo.showDeviceList = false"
            >
              <div class="intercom-device-item click-able">
                <i class="iconfont-lunan icon-lunan-radio"></i>
                <div class="device-name" :title="playInfo.deviceList[0].name">
                  {{ playInfo.deviceList[0].name }}
                </div>
                <i
                  class="el-icon-caret-bottom device-expand-icon"
                  :class="{ expand: playInfo.showDeviceList }"
                ></i>
              </div>
              <div
                class="device-list-area top map-blur-panel__title"
                :style="{
                  height: (playInfo.deviceList.length - 1) * 30 + 'px',
                }"
                :class="{ hidden: !playInfo.showDeviceList }"
              >
                <el-scrollbar style="height: 100%">
                  <template v-for="(item, index) in playInfo.deviceList">
                    <div
                      v-if="index !== 0"
                      class="intercom-device-item click-able"
                      :key="'play-device-' + index"
                      :title="item.name"
                    >
                      <i class="iconfont-lunan icon-lunan-radio"></i>
                      <div class="device-name" :title="item.name">
                        {{ item.name }}
                      </div>
                    </div>
                  </template>
                </el-scrollbar>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="intercom-device">
              <div class="device-name">无广播设备</div>
            </div>
          </template>
          <div
            v-if="playInfo.deviceList && playInfo.deviceList.length"
            style="display: contents"
          >
            <div class="intercom-operate">
              <template>
                <div class="audio-button-area">
                  <el-tooltip content="上一首" effect="dark">
                    <i
                      class="click-able el-icon-arrow-left audio-button"
                      @click="previousAudio"
                    ></i>
                  </el-tooltip>
                  <el-tooltip
                    :content="playInfo.processing ? '暂停' : '播放'"
                    effect="dark"
                  >
                    <i
                      @click="togglePlayAudio"
                      class="click-able audio-button"
                      :class="
                        playInfo.processing
                          ? 'el-icon-video-pause play-icon'
                          : 'el-icon-video-play stop-icon'
                      "
                    ></i>
                  </el-tooltip>
                  <el-tooltip content="下一首" effect="dark">
                    <i
                      class="click-able el-icon-arrow-right audio-button"
                      @click="nextAudio"
                    ></i>
                  </el-tooltip>
                </div>
              </template>
            </div>
            <div
              class="intercom-volume"
              :class="{ 'click-able': playInfo.processing }"
              @mouseover="playInfo.showVolume = playInfo.processing"
              @mouseout="playInfo.showVolume = false"
            >
              <div class="intercom-volume-bar active">
                <el-slider
                  v-model="playInfo.broadcastVolume"
                  :max="15"
                  @change="
                    (val) => {
                      handleVoice(val, playInfo.deviceList);
                    }
                  "
                ></el-slider>
              </div>
              <i class="iconfont-lunan icon-lunan-guangbo"></i>
            </div>
            <el-tooltip content="关闭播放" effect="dark">
              <div class="intercom-close click-able" @click="closePlay">
                <i class="el-icon-close"></i>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <app-panel
      title="远程喊话"
      :isExpand="showIntercomPanel"
      :transparent="isTransparent"
      :modal="false"
      @cancel="closeIntercomForm"
      :width="350"
    >
      <el-scrollbar style="flex: 1">
        <div class="add-content">
          <el-form ref="intercomForm" :model="intercomForm" class="add-form">
            <el-form-item
              prop="sourceId"
              label="选择话筒"
              :rules="intercomRules.sourceId"
            >
              <template>
                <!--                  <span>从地图选择广播设备</span>-->
                <el-button
                  @click="chooseIntercom"
                  icon="el-icon-plus"
                  style="position: absolute; right: 10px; top: 0px"
                >
                  添加
                </el-button>

                <div class="intercom-content">
                  <div class="content_value" v-if="intercomForm.sourceName">
                    {{ intercomForm.sourceName || "" }}
                    <!-- <el-input v-model="intercomForm.sourceId" readonly></el-input> -->
                  </div>
                  <div class="no-data-text" v-else>设备列表为空</div>
                </div>
              </template>
            </el-form-item>
            <el-form-item
              prop="deviceList"
              label="已选广播设备"
              :rules="intercomRules.deviceList"
            >
              <span>({{ intercomForm.deviceList.length || 0 }})</span>
              <template>
                <!--                  <span>从地图选择广播设备</span>-->
                <el-button
                  @click="handleChooseDevice(2)"
                  icon="el-icon-plus"
                  style="position: absolute; right: 10px"
                >
                  添加
                </el-button>

                <div class="add-list">
                  <template
                    v-if="intercomForm.deviceList && intercomForm.deviceList.length"
                  >
                    <el-scrollbar style="height: 100%">
                      <div class="device-content">
                        <div
                          class="device-item"
                          v-for="(item, index) in intercomForm.deviceList"
                          :key="'intercom-device-' + index"
                        >
                          <div class="flex-auto text-ellipse" :title="item.name">
                            <i class="item-icon iconfont-lunan icon-lunan-radio"></i>
                            <span>{{ item.name || item.attr.thirdDeviceName }}</span>
                          </div>
                          <el-button
                            title="删除"
                            type="text"
                            class="font20"
                            icon="el-icon-remove-outline"
                            @click="toggleDevice(item)"
                          ></el-button>
                        </div>
                      </div>
                    </el-scrollbar>
                  </template>
                  <template v-else>
                    <div class="no-data-text">设备列表为空</div>
                  </template>
                </div>
              </template>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="add-footer" slot="footer">
        <el-button type="info" @click="closeIntercomForm">取消</el-button>
        <el-button type="primary" @click="confirmIntercomForm">确定</el-button>
      </div>
    </app-panel>

    <div class="play-panel">
      <play-panel
        ref="playRef"
        panelTitle="播放音频"
        :checkedAudios="checkedAudios"
        :checkPlayDevices="checkPlayDevices"
        :showPlayPanel="showPlayPanel"
        @toggleDevice="toggleDevice"
        :model="false"
        @closePlayForm="closePlayForm"
        @handleChooseDevice="handleChooseDevice"
        @addAudio="addAudio"
      ></play-panel>
    </div>
    <app-panel
      :title="devicePanelTitle"
      :isExpand="showIntercomList"
      :transparent="isTransparent"
      :modal="false"
      @cancel="handleListClose"
      :width="350"
    >
      <div class="intercom-table">
        <!--远程喊话--话筒-->
        <div class="table_content">
          <div style="height: 100%" v-if="isType == 1">
            <div class="table_search">
              <el-input :placeholder="panelPlaceholder" v-model="filterText"></el-input>
            </div>
            <el-scrollbar style="height: calc(100% - 50px); padding: 10px 0">
              <el-tree
                ref="panelDeviceTree"
                :data="sourceData"
                highlight-current
                :default-expanded-keys="expandedKeys"
                node-key="id"
                :props="treeProps"
                :default-expand-all="true"
                :filter-node-method="filterNode"
              >
                <div
                  slot-scope="{ data }"
                  :title="'话筒：' + data.name"
                  class="showOverText"
                  style="width: 100%"
                >
                  <i
                    v-show="data.nodeType === 'device'"
                    style="color: #3e76e6"
                    class="el-icon-microphone"
                  ></i>
                  <span style="margin-left: 5px">{{ data.name }}</span>
                </div>
              </el-tree>
            </el-scrollbar>
          </div>
          <!--播放音频--广播||远程喊话--广播-->
          <div style="height: 400px" v-if="isType == 4 || isType == 2">
            <alarm-radio-dialog
              ref="deviceTree"
              @deviceClick="deviceClick"
              @cameraData="handleDeviceClick"
            ></alarm-radio-dialog>
          </div>
          <!--播放音频--话筒-->
          <div style="height: 400px" v-if="isType == 3">
            <div class="table_search">
              <el-input
                :placeholder="panelPlaceholder"
                v-model="audioName"
                width="80%"
                @keydown.enter.native="filterAudio(audioName)"
                clearable
              ></el-input>
              <img
                style="margin-left: 5px; cursor: pointer"
                @click="filterAudio(audioName)"
                src="@src/common/assets/images/search.png"
                alt=""
              />
              <!-- <el-button
                style="position: absolute; right: 20px"
                type="text"
                @click="filterAudio(audioName)"
                icon="el-icon-search"
              ></el-button> -->
            </div>
            <el-scrollbar style="height: 400px">
              <el-checkbox-group v-model="choosedAudiosCopy" @change="audioChange">
                <div class="check-content" v-for="item in audioData" :key="item.name">
                  <el-checkbox :label="item.name"></el-checkbox>
                </div>
              </el-checkbox-group>
            </el-scrollbar>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="closeAudioDialog">取消</el-button>
        <el-button type="primary" @click="confirmAudioDialog">确认</el-button>
      </div>
    </app-panel>
    <!--设备面板-->

    <!-- 摄像机弹窗 -->
    <el-dialog
      title="广播设备列表"
      :visible.sync="dialogVisible"
      width="400px"
      v-dialogDrag
      :before-close="handleClose"
    >
      <el-scrollbar style="height: 400px">
        <alarm-radio-dialog
          ref="deviceTree"
          @cameraData="handleDeviceClick"
        ></alarm-radio-dialog>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitDialog">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import appPanel from "@src/components/business/app-panel/index.vue";
import { api } from "../api";
import chooseIntercomSource from "../components/choose-intercom-source.vue";
import AlarmRadioDialog from "../../realTimeAlarm/alarm-radio-dialog";
import playPanel from "../components/playPanel.vue";
// import devicePanel from "../components/devicePanel.vue";
import Vue from "vue";
export default {
  components: {
    AlarmRadioDialog,
    // chooseIntercomSource,
    appPanel,
    playPanel,
    // devicePanel,
  },
  data() {
    return {
      pageState: "",
      showIntercomPanel: false,
      showPlayPanel: false,
      showIntercomList: false, //话筒列表面板
      isTransparent: true,
      sourceData: [],
      treeProps: {
        label: "name",
        children: "subTreeModelList",
      },
      expandedKeys: [],
      dialogVisible: false,
      showPlay: false,
      showIntercom: false,
      intercomInfo: {
        isEmpty: true,
        processing: false,
        showVolume: false,
        broadcastVolume: 30,
        showDeviceList: false,
        deviceList: [],
      },
      isIntercomRefreshing: false,
      playInfo: {
        isEmpty: true,
        processing: false,
        showVolume: false,
        broadcastVolume: 30,
        showDeviceList: false,
        deviceList: [],
        audioList: [],
        audioIndex: 0,
      },

      playForm: {
        deviceList: [],
        playTime: 60,
        playOrder: "0",
        audioList: [],
      },
      playRules: {
        deviceList: [
          {
            required: true,
            message: "请选择广播设备",
            trigger: "change",
          },
        ],
        playTime: [
          {
            required: true,
            message: "请输入音频播放时长",
            trigger: "change",
          },
        ],
        playOrder: [
          {
            required: true,
            message: "请选择音频播放顺序",
            trigger: "change",
          },
        ],
        audioList: [
          {
            required: true,
            message: "请选择播放音频",
            trigger: ["change"],
          },
        ],
      },
      activeSource: "1",
      sourceTemplates: [],
      intercomForm: {
        deviceList: [],
        sourceId: "",
      },
      intercomRules: {
        deviceList: [
          {
            required: true,
            message: "请选择广播设备",
            trigger: "change",
          },
        ],
        sourceId: [
          {
            required: true,
            message: "请选择源终端",
            trigger: ["change"],
          },
        ],
      },
      sourceForm: {
        sourceId: "",
        name: "",
        sourceName: "",
      },
      saveasTemplate: false,
      sourceRules: {
        sourceId: [
          {
            required: true,
            message: "请选择源终端",
            trigger: "change",
          },
        ],
        // name: [
        //   {
        //     required: true,
        //     message: "请输入模板名称",
        //     trigger: "blur",
        //   },
        // ],
      },
      chooseAudio: false,
      audioData: [],
      broadcastList: [],
      broadcastListCopy: [],
      devicePanelTitle: "", //右侧面板名称
      panelPlaceholder: "",
      isType: 1, //1:话筒 2公共广播 3 音频文件 4 广播
      choosedAudiosCopy: [],
      filterText: "",
      audioName: "",
      addMarketList: [],
      audioDataCopy: [],
      broadcastLayer: "BROAD-CAST_LAYER",
      checkedAudios: [],
      checkPlayDevices: [],
      broadcastSrc: "images/theme/newDark/map/resource/broadcast_inactive.png", //默认广播
      broadcastCheckSrc: "images/theme/newDark/map/resource/broadcast-call.png", //广播喊话
      broadcastCheckPlaySrc: "images/theme/newDark/map/resource/broadcast-audio.png", //音频播放
      isSuccess: false, //判断是否提交远程喊话or播放音频的标志
    };
  },
  watch: {
    filterText(val) {
      this.$refs.panelDeviceTree.filter(val);
    },
    filterAudio(val) {
      console.log(this.audioData, "this.audioData");
    },
  },
  computed: {
    currentTheme() {
      return this.$store.getters.currentTheme;
    },
  },
  beforeDestroy() {
    this.$map.hideMap2D();
    // this.$map.clear();
    // this.$map.MapInstance2D.clearPoint();
  },
  mounted() {
    // if (!window.systemConfig.LOAD_MAP) {
    //   this.initPage();
    // }
    this.$map.showMap2D(this.initPage);
    this.getAudioList();
    this.$forceUpdate();
    this.sourceTemplates = [];
    this.choosedIds = [];

    /**
     * 地图点击事件
     */
    // this.$map.addClickEvent((data) => {
    //   console.log(data, "====dataclick");
    //   console.log("11111");
    //   if (this.showPlayPanel || this.showIntercomPanel) {
    //     let item = data.attr || {};
    //     console.info("deviceName", item);
    //     this.toggleDevice(item);
    //   }
    // });
  },
  methods: {
    deviceClick(data) {
      data.disabled && this.showIntercomPanel
        ? this.$message.warning("该设备已绑定播放音频")
        : data.disabled && this.showPlayPanel
        ? this.$message.warning("该设备已绑定远程喊话")
        : "";
    },

    filterAudio(val) {
      let tempArr = [];
      console.log(val, "val");
      if (!val) {
        this.audioData = this.audioDataCopy;
      }
      this.audioData = this.audioData.forEach((item) => {
        if (item.name.indexOf(val) > -1) {
          tempArr.push(item);
        }
      });
      this.audioData = [...tempArr];
    },
    // 图标点击事件
    handleMapClick(e, b) {
      console.log(e, b, "----e,b");
      let isSelect = false;
      if (this.showPlayPanel) {
        isSelect = this.intercomInfo.deviceList.some((item) => {
          return item.id == e.marker.attr.thirdDeviceId;
        });
        isSelect
          ? this.$message.warning("该设备已绑定远程喊话")
          : this.toggleDevice(e.marker, true);
        // this.intercomInfo.deviceList.map((item) => {
        //   if (item.id == e.marker.attr.id) {
        //     this.$message.warning("该设备已绑定远程喊话");
        //     return;
        //   }
        // });
      } else if (this.showIntercomPanel) {
        isSelect = this.playInfo.deviceList.some((item) => {
          return item.id == e.marker.attr.thirdDeviceId;
        });
        isSelect
          ? this.$message.warning("该设备已绑定播放音频")
          : this.toggleDevice(e.marker, true);
      } else {
        const tipID = "device_popup";
        this.$map.MapInstance2D.addPopupMap({
          offset: [10, 12],
          position: e.marker.coord,
          content: '<div id="device_popup"></div>',
          contentId: tipID,
          layerId: tipID,
        });
        let deviceTip = new this.$map.MapInstance2D.vueComponents.deviceDetailTip().$mount(
          "#" + tipID
        );
        deviceTip.data = e.marker.attr;
        deviceTip.$on("tipClose", () => {
          this.$map.MapInstance2D.removePopup(tipID);
        });
        // 广播喊话
        deviceTip.$on("handleDeviceShout", (info) => {
          console.log(info, "000000inf");
          this.handleIntercom(false);
          console.log(this.intercomInfo.deviceList, "deviceList");
          this.toggleDevice({
            attr: {
              thirdDeviceId: info.thirdDeviceId,
            },
            name: info.deviceName,
          });
        });
        // // 广播播放
        deviceTip.$on("handleDeviceMusic", (info) => {
          console.log(info, "000000inf");
          this.togglePlayForm(false);
          this.toggleDevice({
            attr: {
              thirdDeviceId: info.thirdDeviceId,
            },
            name: info.deviceName,
          });
        });
      }
      // if (this.showPlayPanel || this.showIntercomPanel) {
      //   this.toggleDevice(e.marker, true);
      // } else {
      //   return;
      // }
    },
    //过滤话筒
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    getSourceData() {
      const params = {
        // 设备子类型 26-广播（包含广播和麦克风），18-摄像机
        deviceMarkList: [26],
        // 是否需要权限过滤，0：不过滤，1：过滤
        authorityFlag: 1,
      };
      this.$fetch(api.queryAreaDeviceTree, params).then((res) => {
        if (res.success) {
          let arr = [];
          arr = res.returnObj || [];
          arr.forEach((item) => {
            // if(item.subTreeModelList){
            // }
          });
          this.sourceData = res.returnObj || [];
          if (this.sourceData && this.sourceData.length) {
            this.expandedKeys = [this.sourceData[0].id];
          }
        } else {
          this.$message.error(res.msgContent || "查询源终端列表失败");
        }
      });
    },
    //递归树结构
    menusDataPro(data, compareData) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = { ...item };
          if (item.children) {
            entity.children = self.menusDataPro(item.children, compareData);
          } else {
            compareData.forEach((val) => {
              console.log(entity, val, "**************entity");
              if (entity.thirdCameraId == val.id) {
                entity.disabled = true;
              }
            });
            // item.forEach((el) => {
            //   this.playInfo.deviceList.forEach((val) => {
            //     if (el.thirdCameraId == val.id) {
            //       entity.disabled = true;
            //     }
            //   });
            // });
          }
          result.push(entity);
          console.log(result, "===result");
        });
        return result;
      }
    },
    handleChooseDevice(type) {
      this.showIntercomList = true;
      this.devicePanelTitle = "添加广播设备";
      this.isType = type;
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.deviceTree.dataList = this.menusDataPro(
            this.$refs.deviceTree.dataList,
            this.playInfo.deviceList
          );
        }, 500);

        // this.$refs.deviceTree.dataList = this.menusDataPro(
        //   this.$refs.deviceTree.dataList
        // );
      });
      if (this.choosedIds && this.choosedIds.length > 0) {
        console.log("check", this.choosedIds);
        this.$nextTick(() => {
          this.$refs.deviceTree.setChecked(this.choosedIds);
        });
      }
      // this.dialogVisible = true;
    },
    handleDeviceClick(data) {
      console.log(data, "handleDeviceClick");
      this.videoData = data.map((item) => {
        return {
          id: item.thirdCameraId,
          coord: [
            item.longitude ? Number(item.longitude.slice(0, 10)) : null,
            item.latitude ? Number(item.latitude.slice(0, 10)) : null,
          ],
          longitude: item.longitude ? Number(item.longitude.slice(0, 10)) : null,
          latitude: item.latitude ? Number(item.latitude.slice(0, 10)) : null,
          attr: {
            name: item.name,
            playDuration: item.playDuration,
            area: item.area,
            thirdDeviceId: item.thirdCameraId,
          },
          src: "images/theme/newDark/map/resource/broadcast_red.png",
          scale: 0.8,
          name: item.name,
          systemId: item.systemId,
          systemName: item.systemName,
        };
      });
    },

    handleClose() {
      this.dialogVisible = false;
    },
    toggleDevice(item, isMapEdit = false) {
      console.log(item);
      // console.log(
      //   item,
      //   this.showIntercomPanel,
      //   this.showPlayPanel,
      //   this.intercomForm.deviceList,
      //   "---toggleDevice---item"
      // );
      let choosedIndex = this.choosedIds.indexOf(
        item?.attr.thirdDeviceId || item.thirdDeviceId
      );
      // console.log("choose", choosedIndex, this.choosedIds);
      // this.$map.MapInstance2D.removePoint(item.marker.id);
      let id = "";
      if (item?.attr) {
        // id = item.id.replace("broadcastLayer-", "");
        id = item.attr.thirdDeviceId;
      } else {
        id = item.thirdDeviceId;
      }
      // console.log(id, this.intercomForm.deviceList, "-------------id");
      if (choosedIndex === -1) {
        let point = "";
        this.showIntercomPanel
          ? (point = this.getMapPoint(item, "-live_selected"))
          : (point = this.getMapPoint(item, "-play_selected"));
        this.$map.MapInstance2D.updateFeatureById(
          this.broadcastLayer,
          this.broadcastLayer + "-" + id,
          {
            src: point.src,
          }
        );
        this.choosedIds.push(item.thirdDeviceId || item.attr.thirdDeviceId || item.id);
        let obj = {};
        if (isMapEdit) {
          let target = { name: item.attr.name };
          obj = Object.assign(target, item);
        } else {
          obj = item;
        }

        if (this.isType == 4 || this.showPlayPanel) {
          this.checkPlayDevices.push(obj);
          this.$refs.playRef.$refs.playForm.validateField("deviceList");
        }

        if (this.isType == 2 || this.showIntercomPanel) {
          this.intercomForm.deviceList.push(obj);
          this.$refs.intercomForm.validateField("deviceList");
          // this.$refs.intercomForm
        }
      } else {
        let status = item.attr.status == 0 ? "_outline" : "";
        let point = this.getMapPoint(item, status);
        this.$map.MapInstance2D.updateFeatureById(
          this.broadcastLayer,
          this.broadcastLayer + "-" + id,
          {
            src: point.src,
          }
        );
        this.choosedIds.splice(choosedIndex, 1);
        if (this.isType == 4 || this.showPlayPanel) {
          this.checkPlayDevices.splice(choosedIndex, 1);
        }
        if (this.isType == 2 || this.showIntercomPanel) {
          this.intercomForm.deviceList.splice(choosedIndex, 1);
        }
      }
      // console.log(
      //   this.choosedIds,
      //   this.intercomForm.deviceList,
      //   "****************chooseIds devicelist"
      // );
    },
    handleMarkerClick() {},
    resetMap() {
      console.log("restMap");
      this.choosedIds = [];
      this.$map.MapInstance2D.clearPoint();
      this.$map.MapInstance2D.addMarket(this.broadcastList);
    },
    initPage() {
      Promise.all([this.getBroadcastList(), this.queryIntercom(), this.queryPlay()]).then(
        () => {
          this.deviceMark();
        }
      );
      // .then(() => {
      //   this.$map.MapInstance2D.addMarket(
      //     this.broadcastListCopy,
      //     this.broadcastLayer,
      //     this.handleMapClick
      //   );
      // });

      // this.queryIntercom();
      // this.queryPlay();
    },
    //查询广播设备
    async getBroadcastList() {
      return new Promise((resolve) => {
        const params = {
          // 广播设备类型为26
          deviceType: 26,
          page: 1,
          pageSize: 1000,
        };
        this.$fetch(api.getDeviceListByPage, params).then((res) => {
          if (res.success) {
            this.broadcastListCopy = [];
            this.broadcastList = [];
            res.returnObj.list.forEach((item, index) => {
              let type = "";
              item.status == 0 ? (type = "_outline") : "";
              let addMarkInfo = this.getMapPoint(item, type);
              this.broadcastList.push(addMarkInfo);
            });
            this.broadcastListCopy = this.broadcastList.concat(this.broadcastListCopy);
            resolve(this.broadcastListCopy);
            console.log(
              this.broadcastListCopy,
              this.broadcastList,
              "===9999 this.broadcastListCopy"
            );
          } else {
            this.$message.error(res.msgContent || "查询广播设备列表失败");
          }
        });
      });
    },
    async queryIntercom() {
      return new Promise((resolve) => {
        this.$fetch(api.queryRemoteCall).then((res) => {
          this.isIntercomRefreshing = false;
          if (res.success) {
            let result = res.returnObj || {};
            let deviceList = (result.targetTerminalInfoList || []).map((item) => {
              return {
                id: item.targetTerminalId,
                name: item.targetTerminalName,
                longitude: item.longitude,
                latitude: item.latitude,
              };
            });
            this.intercomInfo = {
              isEmpty: deviceList.length > 0 ? false : true,
              processing: result.stop === "0",
              showVolume: false,
              broadcastVolume: 30,
              showDeviceList: false,
              deviceList: deviceList,
              sourceId: result.sourceTerminalId,
              sourceName: result.sourceTerminalName,
            };
            resolve(this.intercomInfo);
            // this.deviceMark(this.intercomInfo.deviceList, "intercom");
          } else {
            this.$message.error(res.msgContent);
            this.intercomInfo.isEmpty = true;
            this.$log.error("查询远程喊话信息失败");
          }
        });
      });
    },
    async queryPlay() {
      return new Promise((resolve) => {
        this.$fetch(api.queryPlayAudio).then((res) => {
          this.isPlayRefreshing = false;
          if (res.success) {
            let result = res.returnObj || {};
            let deviceList = (result.terminalInfoList || []).map((item) => {
              return {
                id: item.terminalId,
                name: item.terminalName,
                longitude: item.longitude,
                latitude: item.latitude,
              };
            });
            this.playInfo = {
              isEmpty: deviceList.length > 0 ? false : true,
              processing: result.controlType && result.controlType != "pause",
              showVolume: false,
              broadcastVolume: 30,
              showDeviceList: false,
              deviceList: deviceList,
              sourceId: result.sourceTerminalId,
              sourceName: result.sourceTerminalName,
              audioList: [],
              audioIndex: 0,
            };
            resolve(this.playInfo);
            // this.deviceMark(this.playInfo.deviceList, "play");
          } else {
            this.playInfo.isEmpty = true;
            this.$log.error("查询音频播放信息失败");
          }
        });
      });
    },
    deviceMark() {
      let broadcastList = [];
      // console.log(
      //   this.broadcastListCopy,
      //   this.intercomInfo.deviceList,
      //   "====this.broadcastListCopy"
      // );
      this.broadcastListCopy.forEach((item) => {
        let obj = { ...item };
        let isCall = this.intercomInfo.deviceList.some((el) => {
          // console.log(obj, el, "=interform==onj");
          return el.id == item.id;
        });
        let isAudio = this.playInfo.deviceList.some((el) => {
          // console.log(obj, el, "===lay");
          return el.id == item.id;
        });
        let checkType = isAudio ? "audio" : isCall ? "call" : ""; //audio:音频播放设备，call:广播喊话设备
        item.checkType = checkType;
        obj.attr.checkType = checkType;
        obj.src =
          checkType == "audio"
            ? this.broadcastCheckPlaySrc
            : checkType == "call"
            ? this.broadcastCheckSrc
            : item.src;
        broadcastList.push(obj);
      });
      // console.log(this.constList.broadcast);
      this.$map.MapInstance2D.addMarket(
        broadcastList,
        this.broadcastLayer,
        this.handleMapClick
      );
      // let pointList = [];
      // let addMarkInfo = {};
      // arr.forEach((el) => {
      //   let srcType = "";
      //   type == "intercom"
      //     ? (srcType = "-live_selected")
      //     : (srcType = "-play_selected");
      //   addMarkInfo = this.getMapPoint(el, srcType);
      //   pointList.push(addMarkInfo);
      // });
      // console.log(this.broadcastListCopy, pointList, type, "===copy");
      // this.$map.MapInstance2D.addMarket(pointList, type, this.handleMapClick);
      // this.broadcastListCopy.forEach((item, index) => {
      //   console.log(item, index, "=====item21");
      //   arr.forEach((el) => {
      //     if (item.attr.thirdDeviceId == el.id) {
      //       console.log(el, item, "=====item");

      //       this.broadcastListCopy.splice(index, 1);
      //     }
      //   });
      // });
    },
    getMapPoint(item = {}, type = "") {
      return {
        id: item.thirdDeviceId || item.id,
        coord: [Number(item.longitude), Number(item.latitude)],
        longitude: item.longitude,
        latitude: item.longitude,
        anchor: [10, 12],
        scale: 1,
        src: `images/theme/${this.currentTheme}/map/resource/broadcast${type}.png`,
        attr: item,
        name: item.name,
        tipsTitle: "广播设备详情",
        showTips: true,
        tipsMap: {
          deviceName: "设备名称",
        },
      };
    },
    getAudioList() {
      const params = {
        pageNum: 1,
        pageSize: 1000,
      };
      this.$fetch(api.queryAudio, params).then((res) => {
        if (res.success) {
          this.audioData = (res.returnObj && res.returnObj.list) || [];
          this.audioDataCopy = [...this.audioData];
        } else {
          this.$message.error(res.msgContent || "查询音频列表失败");
        }
      });
    },
    audioChange(data) {
      this.choosedAudiosCopy = data;
    },
    addAudio() {
      // this.chooseAudio = true;
      this.showIntercomList = true;
      this.devicePanelTitle = "添加要播放的音频";
      this.panelPlaceholder = "按名称搜索音频文件";
      this.isType = 3;
    },
    closeAudioDialog() {
      this.audioName = "";
      this.filterText = "";
      this.showIntercomList = false;
      this.choosedAudiosCopy = [];
    },
    confirmAudioDialog() {
      console.log(this.isType);
      if (this.isType == 3) {
        if (!this.choosedAudiosCopy || !this.choosedAudiosCopy.length > 0) {
          this.$message.warning("请选择音频");
          return;
        }
        this.checkedAudios = this.choosedAudiosCopy || [];
        this.$refs.playRef.$refs.playForm.validateField("audioList");
        this.$refs.playRef.$refs.playForm.validateField("deviceList");
      } else if (this.isType == 4 || this.isType == 2) {
        if (!this.videoData || !this.choosedIds) {
          this.$message.warning("请选择广播设备");
          return;
        }
        console.log("222222222222jiaoyan", this.choosedIds);
        this.choosedIds = [];
        this.submitDialog();
        this.isType == 2
          ? this.$refs.intercomForm.validateField("deviceList")
          : this.$refs.playRef.$refs.playForm.validateField("deviceList");
      } else {
        if (!this.$refs.panelDeviceTree.getCurrentNode()) {
          this.$message.warning("请选择话筒");
          return;
        }
        let checkedNode = this.$refs.panelDeviceTree.getCurrentNode();
        let NodeList = [];
        if (checkedNode.deviceType !== "26") {
          this.$message.error("当前选择的不是广播设备类型");
          this.$log.info("当前选择的设备不是广播设备");
          return;
        }
        NodeList.push(checkedNode);
        this.intercomForm.audioList = NodeList;
        this.intercomForm.sourceId = checkedNode.thirdDeviceId;
        this.intercomForm.sourceName = checkedNode.name;
        this.$refs.intercomForm.validateField("sourceId");
        this.$refs.intercomForm.validateField("audioList");
      }
      this.getBroadcastList();
      this.closeAudioDialog();
    },
    submitDialog() {
      this.showIntercomPanel
        ? (this.intercomForm.deviceList = [])
        : (this.checkPlayDevices = []);
      console.log(this.videoData, "====this.videoData");
      this.videoData.forEach((item) => {
        console.log(item, this.intercomForm.deviceList, "video");
        if (!item.id) {
          return;
        }
        this.toggleDevice(item);
      });
    },
    moveDown(obj, prop, index) {
      let item = this[obj][prop].splice(index, 1)[0];
      this[obj][prop].splice(index + 1, 0, item);
    },
    moveUp(obj, prop, index) {
      let item = this[obj][prop].splice(index, 1)[0];
      this[obj][prop].splice(index - 1, 0, item);
    },
    removeItem(obj, prop, index) {
      this[obj][prop].splice(index, 1);
    },
    handleVoice(val, list) {
      let params = {
        terminalIdList: list.map((el) => {
          return el.id;
        }),
        volume: val,
      };
      this.$fetch(api.setVolume, params).then((res) => {
        if (res.success) {
          this.$message.success(`声音操作成功`);
        } else {
          this.$message.error(res.msgContent || `声音操作失败`);
        }
      });
    },
    closeIntercom() {
      this.$confirm("确定关闭远程喊话吗？", "关闭远程喊话", {
        type: "warning",
      })
        .then((res) => {
          this.$fetch(api.deleteRemoteCall).then((res) => {
            if (res.success) {
              this.$message.success("关闭远程喊话成功");
              this.intercomInfo.deviceList = [];
              this.deviceMark();
              this.queryIntercom();
            } else {
              this.$message.error(res.msgContent || "关闭远程喊话失败");
            }
          });
        })
        .catch((e) => {
          this.$log.debug("用户取消关闭远程喊话");
        });
    },
    closePlay() {
      this.$confirm("确定关闭当前音频播放吗？", "关闭音频播放", {
        type: "warning",
      })
        .then((res) => {
          this.$fetch(api.deletePlayAudio).then((res) => {
            if (res.success) {
              this.$message.success("关闭音频播放成功");
              this.playInfo.deviceList = [];
              this.deviceMark();
              this.queryPlay();
            } else {
              this.$message.error(res.msgContent || "关闭音频播放失败");
            }
          });
        })
        .catch((e) => {
          this.$log.debug("用户取消关闭音频播放");
        });
    },
    handleIntercom(clearIds) {
      this.showIntercomList && this.handleListClose();
      if (this.showIntercomPanel == true) {
        this.closeIntercomForm();
        setTimeout(() => {
          this.handleIntercom(clearIds);
        }, 400);
        return;
      }
      this.showIntercomPanel = true;
      this.showPlayPanel = false;
      this.$map.MapInstance2D.clearPoint();
      // this.queryIntercom();
      // this.intercomInfo.deviceList = [];
      this.deviceMark();
      if (!this.isSuccess) {
        this.choosedIds.splice(this.choosedIds.length - 1, 1);
        this.intercomForm.deviceList.splice(this.intercomForm.deviceList.length - 1, 1);
      } else if (clearIds) {
        this.choosedIds = [];
      }
    },
    togglePlayForm() {
      this.showIntercomList && this.handleListClose();
      if (this.showPlayPanel == true) {
        this.$refs.playRef.closePlayForm();
        setTimeout(() => {
          this.togglePlayForm();
        }, 400);
        return;
      }
      this.showIntercomPanel = false;
      this.showPlayPanel = true;
      this.$map.MapInstance2D.clearPoint();
      this.isSuccess = false;
      // this.playInfo.deviceList = [];
      this.deviceMark();
      if (!this.isSuccess) {
        this.choosedIds.splice(this.choosedIds.length - 1, 1);
        this.checkPlayDevices.splice(this.checkPlayDevices.length - 1, 1);
      } else if (clearIds) {
        this.choosedIds = [];
      }
    },
    //选择话筒
    chooseIntercom() {
      this.showIntercomList = true;
      this.devicePanelTitle = "添加话筒";
      this.isType = 1;
      this.panelPlaceholder = "按名称搜索话筒";
      this.getSourceData();
    },
    handleListClose() {
      this.showIntercomList = false;
    },
    handlePanelClose() {
      this.showIntercomPanel = false;
      console.log(this.choosedIds, "chooseids");
      this.intercomForm.deviceList.forEach((item) => {
        this.toggleDevice(item);
      });
      this.intercomForm = {
        deviceList: [],
        sourceId: "",
        sourceName: "",
      };
    },
    handlePlayPanelClose() {
      this.showPlayPanel = false;
      console.log(this.playForm.deviceList, "platfoem-devicelist");

      this.playForm.deviceList.forEach((item) => {
        console.log(item, "quxiao---item");
        this.toggleDevice(item);
      });
      this.choosedAudiosCopy = [];
      this.playForm = {
        audioList: [],
        deviceList: [],
      };
    },
    toggleStopIntercom() {
      if (this.isIntercomRefreshing) {
        this.$log.info("正在操作当前喊话，请勿重复操作");
        return;
      }
      this.isIntercomRefreshing = true;
      let params = {
        // 源终端ID
        sourceTerminalId: this.intercomInfo.sourceId,
        // 0 开始 1 停止， 如果当前是开始状态，则修改为'1'（停止）；如果当前是停止状态，则修改为'0'（开始）
        stop: this.intercomInfo.processing ? "1" : "0",
        //目标终端ID列表
        targetTerminalIdList: Array.from(
          new Set(
            this.intercomInfo.deviceList.map((item) => {
              return item.id;
            })
          )
        ),
      };
      this.saveIntercomForm(params, this.intercomInfo.processing ? "停止" : "开启");
    },
    confirmIntercomForm() {
      this.$refs.intercomForm.validate((result) => {
        if (result) {
          let params = {
            // 源终端ID
            sourceTerminalId: this.intercomForm.sourceId, //this.intercomForm.sourceId,
            // 0 开始 1 停止
            stop: "0",
            //目标终端ID列表
            targetTerminalIdList: Array.from(
              new Set(
                this.intercomForm.deviceList.map((item) => {
                  let id = "";
                  if (item.id) {
                    id = item.id.replace(this.broadcastLayer + "-", "");
                  }
                  return item.thirdDeviceId || id;
                })
              )
            ),
          };
          this.saveIntercomForm(params, "开启", true);
        }
      });
    },
    saveIntercomForm(params, opt = "操作", closeForm) {
      console.log(params, "====parsm");
      let optStr = `远程喊话${opt}`;
      this.$fetch(api.manualRemoteCall, params).then((res) => {
        if (res.success) {
          this.showIntercomPanel = false;
          this.$message.success(`${optStr}成功`);
          if (closeForm) {
            this.closeIntercomForm();
          }
          this.queryIntercom();
          this.queryPlay();
          this.isSuccess = true;
        } else {
          this.isIntercomRefreshing = false;
          this.$message.error(res.msgContent || `${optStr}失败`);
        }
      });
    },

    closeIntercomForm() {
      this.initPage();
      // this.intercomForm.deviceList = [];
      this.showIntercomPanel = false;
      this.intercomForm = this.$options.data().intercomForm;
      this.$refs.intercomForm.resetFields();
      this.isSuccess = false;
    },

    confirmPlayForm() {
      this.$refs.playForm.validate((res) => {
        if (res) {
          // this.closePlayForm();
          let audioList = this.playForm.audioList.map((item) => {
            return item;
          });
          let deviceList = this.playForm.deviceList.map((item) => {
            let id = "";
            if (item.id) {
              id = item.id.replace("BROAD_CAST_LAYER-", "");
            }
            return item.thirdDeviceId || id;
          });
          let params = {
            // 播放时长 单位秒
            durations: this.playForm.playTime,
            // 文件名称列表
            fileList: audioList,
            // 1：随机播放 0：顺序播放
            randomPlay: this.playForm.playOrder,
            // 播放状态 startbct(开始广播) stopbct（停止广播）filecontrol （ 播放控制）  此接口固定传startbct(开始广播)
            rtType: "startbct",
            // 广播设备ID列表
            terminalIdList: deviceList,
          };
          this.$fetch(api.playAudio, params).then((res) => {
            if (res.success) {
              this.$message.success("111音频播放成功");
              console.log("音频播放成功");
              this.closePlayForm();
              this.isSuccess = true;
            } else {
              this.$message.error(res.msgContent || "音频播放失败");
            }
          });
        }
      });
      this.choosedAudiosCopy = [];
    },
    closePlayForm() {
      console.log("取消-----------------------");
      this.initPage();
      this.showPlayPanel = false;
      this.isSuccess = false;
      this.checkPlayDevices = [];
    },

    previousAudio() {
      this.controlPlayAudio("previous");
    },
    nextAudio() {
      this.controlPlayAudio("next");
    },
    togglePlayAudio() {
      console.log("播放", this.playInfo.processing);
      // this.playInfo.processing = !this.playInfo.processing;
      console.log("播放1", this.playInfo.processing);
      // 如果当前正在播放，则设置为暂停；如果当前是暂停状态，则设置为播放
      this.controlPlayAudio(this.playInfo.processing ? "pause" : "play");
    },
    controlPlayAudio(controlType) {
      if (this.isPlayRefreshing) {
        this.$log.info("正在操作当前音频播放，请勿重复操作");
        return;
      }
      let optStr = {
        play: "恢复播放",
        pause: "暂停播放",
        next: "音频播放下一首",
        previous: "音频播放上一首",
      };
      let params = {
        // 控制类型： play: 播放 pause: 暂停 next: 下一首 previous: 上一首
        controlType: controlType,
        // 播放状态 startbct(开始广播) stopbct（停止广播）filecontrol （ 播放控制）  此接口固定传filecontrol（ 播放控制）
        rtType: "filecontrol",
        // 广播ID列表
        terminalIdList: Array.from(
          new Set(
            this.playInfo.deviceList.map((item) => {
              return item.id;
            })
          )
        ),
      };
      this.isPlayRefreshing = true;
      this.$fetch(api.controlPlayAudio, params).then((res) => {
        if (res.success) {
          this.$message.success(`${optStr[controlType]}成功`);
          this.queryPlay();
        } else {
          this.isPlayRefreshing = false;
          this.$message.error(res.msgContent || `${optStr[controlType]}失败`);
        }
      });
    },
  },
};
</script>
<style lang="scss">
.app-side-panel__header {
  .title {
    padding: 0px 6px;
    border-left: 4px solid #407aee;
    margin-left: 10px;
  }
}
.add-footer,
.dialog-footer {
  text-align: center;
}
</style>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.showOverText {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  i {
    color: #3e76e6;
  }
}
.font20 {
  font-size: 20px;
}
.buttonBlue {
  width: 100px;
  height: 32px;
  border: none !important;
  border-radius: 5px !important;
  //background: #407aee !important;
}
.add-form {
  .add-item {
    display: flex;
    flex-direction: column;
    // text-align: left;
    .el-form-item__label {
      text-align: left !important;
    }
  }
  .content_value {
    width: 90%;
    padding: 10px;
  }
  .content-noValue {
    color: #dddddd;
    text-align: center;
  }
  .intercom-content {
    // background: rgba(13, 18, 28, 0.65);
    @include set_theme_color(background-color,page-default-bg);
    // padding: 10px;
    margin-top: 21px;
    border-radius: 5px;
    width: 100%;
    display: inline-flex;
  }
  // .device-item {
  //   display: flex;
  //   flex-direction: column;
  // }
}

//设备面板
.intercom-table {
  // background: rgba(24, 31, 46, 0.65);
  // padding: 5px 12px;
  height: 100%;
  .table_search {
    margin-bottom: 12px;
    display: flex;
    align-items: center;
  }
  .table_content {
    height: 100%;
    .check-content {
      margin-top: 10px;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #353945;
    }
  }
}
.broadcast-call-page {
  position: relative;
  width: 100%;
  .top-control {
    z-index: 22;
  }
  .text-right {
    text-align: right;
    position: absolute;
    top: 0;
    right: 0;
  }

  .text-center {
    text-align: center;
  }

  .hidden-item {
    visibility: hidden;
  }

  .no-data-text {
    height: 100px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .top-container {
    position: absolute;
    left: 0;
    top: 0;
    height: 50px;
    width: 100%;
    z-index: 2;
    // background-color: rgba(33, 42, 53, 0.8);
    padding: 0 20px;
    // display: flex;
    // align-items: center;
  }
  .operate-area {
    position: relative;
    margin: 12px 0;
  }
  .call-area {
    position: absolute;
    height: 30px;
    width: 700px;
    left: 40%;
    transform: translate(-50%);
    // @include set_theme_color(background-color, menu-tab-bg-color);
    display: flex;
    flex-direction: row;
    align-items: center;
    z-index: 2;

    &.intercom {
      top: 2px;
    }

    &.play {
      top: 2px;
    }

    .intercom-title {
      margin-left: 10px;
      margin-right: 10px;
      padding-right: 10px;
      border-right: 1px solid;
      @include set_theme_color(border-color, table-header-bg-color);
      //  @include set_theme_color(color, font-inactive-color);
    }

    .intercom-device {
      width: 180px;
      margin-right: 10px;
      padding-right: 10px;
      border-right: 1px solid;
      @include set_theme_color(border-color, table-header-bg-color);
      position: relative;

      .intercom-device-item {
        display: flex;
        flex-direction: row;
        padding: 7px 10px;
      }

      .device-expand-icon {
        @include set_animation(transform);

        &.expand {
          transform: rotate(180deg);
        }
      }

      .device-list-area {
        position: absolute;
        overflow: hidden;
        max-height: 180px;
        left: 0;
        width: 100%;
        // @include set_theme_color(background-color, menu-tab-bg-color);
        @include set_animation(height);

        &.hidden {
          height: 0 !important;
        }

        &.top {
          bottom: 30px;
        }

        &.bottom {
          top: 30px;
        }
      }
    }

    .device-name,
    .audio-name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin: 0 5px;
    }

    .intercom-operate {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      justify-content: center;

      &.has-bg {
        padding: 5px;
        border-radius: 3px;
        // @include set_theme_color(background-color, page-tab-item-active-color);
      }

      .operate-btn {
        display: flex;
        flex-direction: row;
      }

      .stop-icon {
        font-size: 20px;
        padding: 2px;
        // height: 16px;
        // width: 16px;
        border-radius: 9px;
        background-color: #ff0000;
      }

      .play-icon {
        font-size: 20px;
        padding: 2px;
        // height: 16px;
        // width: 16px;
        border-radius: 9px;
        background-color: green;
      }

      .operate-text {
        margin-left: 5px;
      }
    }

    .audio-button {
      margin: 0 5px;
      font-size: 20px;
    }

    .intercom-volume {
      padding: 0 10px;
      border-right: 1px solid;
      @include set_theme_color(border-color, table-header-bg-color);
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: not-allowed;
    }

    .intercom-volume-bar {
      width: 0;
      margin-right: 5px;
      overflow: hidden;
      @include set_animation(width);

      .el-slider {
        margin: 0 10px;
      }

      &.active {
        width: 100px;
      }
    }

    .intercom-close {
      height: 30px;
      width: 30px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    .click-able {
      cursor: pointer;

      &:hover {
        @include set_theme_color(color, main-theme-color);
      }
    }
  }
  .device-content {
    padding: 12px;
  }
  .device-item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    overflow: hidden;
    padding: 7px 10px;
    border-bottom: 1px solid #3b4253;
    &:last-child {
      border-bottom: none;
    }
    // @include set_theme_color(border-color, top-menu-border-color);
  }

  .add-container {
    position: absolute;
    z-index: 2;
    top: 50px;
    width: 350px;
    height: calc(100% - 50px);
    // background-color: rgba(28, 31, 39, 0.8);
    @include set_animation(all);
    display: flex;
    flex-direction: column;

    &.left {
      left: -350px;

      &.active {
        left: 0;
      }
    }

    &.right {
      right: -350px;

      &.active {
        right: 0;
      }
    }

    .add-title {
      // padding: 10px;
      margin: 10px;
      padding: 6px;
      font-size: 15px;
      position: relative;
      border-left: 4px solid #407aee;
      // @include set_theme_color(background-color, table-header-bg-color);
    }

    .add-content {
      padding: 10px 20px;
      position: relative;
    }

    .content-title {
      font-size: 15px;
      margin: 10px 0;
    }

    .intercom-source-area {
      border-radius: 3px;
      // @include set_theme_color(background-color, menu-tab-bg-color);
      padding: 0 10px;
    }

    .item-icon {
      margin-right: 5px;
    }

    .add-footer {
      display: flex;
      flex-direction: row;
      justify-content: center;
      padding: 10px 20px;
      position: relative;
      // @include set_theme_color(background-color, table-header-bg-color);
    }
  }

  .audio-comp-list {
    height: 25px;
    width: 300px;
  }

  .el-slider__runway {
    margin: 10px 0;
  }
}
.add-list {
  border-radius: 5px;
  margin-top: 21px;
  @include set_theme_color(background-color,page-default-bg);
  overflow: hidden;
}
.form-column {
  background: rgba(13, 18, 28, 0.5);
  border-radius: 5px;
  // height: 50px;
  padding: 10px;
}
</style>
